import { Component, Input } from '@angular/core';
import { DataFieldTypes } from '@app/enums/data-field-types.enum';
import { DataValue } from '@models/employee/data-value.model';
import { DataFieldGroup } from '@models/settings/data-field-group.model';
import { DataField } from '@models/settings/data-field.model';

// ! THIS COMPONENT IS DEPRECATED: It relies on the old app-grid system and is non-performant. Use app-data-field-group-values instead

@Component({
    selector: 'app-deprecated-data-field-group-values',
    templateUrl: './deprecated-data-field-group-values.template.html',
    styleUrls: ['./deprecated-data-field-group-values.style.scss'],
})
export class DeprecatedDataFieldGroupValuesComponent {
    @Input() group: DataFieldGroup | null = null;
    @Input() dataFields: DataField[] | null = null;
    @Input() dataValues: DataValue[] | null = null;

    dataFieldTypes = DataFieldTypes;

    getDataFieldByGroup(): DataField[] {
        if (!this.group || !this.dataFields) {
            return [];
        }
        return this.dataFields.filter((field: DataField) => field.dataFieldGroup?.id === this.group.id);
    }

    getDataValueByDataField(field: DataField): DataValue {
        if (!this.dataValues) {
            return null;
        }

        return this.dataValues.find((value) => value.dataFieldId === field.id) ?? null;
    }
}
